import React, {useState} from 'react';
import styles from './styles';
import {NavLink} from 'react-router-dom';
import {StyledNavLink} from '@xpertdox_js/xdcomponents';
import { trackActivity } from '../../../utils/activityTracker'
import { UserContext } from '../../../Context/UserContext'
import { InstanceContext } from '../../../InstanceContext'

// the below array has been taken in refereance in line number 34 to disable the menu opening on hover in the nav bar
// only hover is enabled for instances
const includesMenuItems = ['patients', 'trials', 'survey_questions', 'users', 'feedback', 'admin', 'instances'];

const NavItem = props => {
  const [hover, setHover] = useState(false);

  const hoverOn = () => setHover(true);
  const hoverOff = () => setHover(false);
  const { user } = React.useContext(UserContext)
  const { contextInstance } = React.useContext(InstanceContext)

  // const menuPosition = {
  //   top: props.location === 'top' ? 0 : 'auto',
  //   bottom: props.location === 'top' ? 'auto' : 0
  // }
  const handleActivityLogUpdate = (_id) => {
    trackActivity({
      body: {
        _id,
        instance: contextInstance || user.instance,
        user: user.id
      }
    })
  }

  return(
    <div
      style={hover ? {...styles.container, ...styles.containerHov} : styles.container}
      onMouseEnter={hoverOn}
      onMouseLeave={hoverOff}
    >
        <StyledNavLink
          NavLink={NavLink}
          to={props.to}
          styles={styles.iconNavLink}
          hoverStyles={styles.iconNavLinkHov}
          activeStyles={styles.iconNavLinkActive}
        >
        <svg style={styles.icon} xmlns="http://www.w3.org/2000/svg" viewBox='0 0 512 512' onClick={ () => handleActivityLogUpdate(`NavItem.handleActivityLogUpdate.(${props.title ? props.title : ''})`)}>{props.icon }</svg>
        <span style={styles.iconText}>{props.title}</span>
      </StyledNavLink>
      {!includesMenuItems.includes(props.type) && props.items && hover &&
        <div style={
            // {...styles.navMenu, ...menuPosition}
            styles.navMenu
          }>
          <div style={styles.navMenuContent}>
            {props.items}
          </div>
        </div>
      }
    </div>
  )
}


export default NavItem;
